module.exports = __webpack_public_path__ + "img/9788961700566.f1bce075.jpg";